import { useApiCampaignActivityInfo } from '@hooks-api/fortune/useApiCampaignActivityInfo'
import { CampaignStatus } from '@hooks-api/types/dataModel/campaigns'
import { MemberLogins } from '@hooks-api/types/dataModel/fortuneCampaign'
import { useCampaignCode } from './useCampaignCode'

export const useCampaignSetting = () => {
  const { campaignCodeFromUrl } = useCampaignCode()
  const { destructuredData: campaign } = useApiCampaignActivityInfo(campaignCodeFromUrl)
  const isMemberLoginTypeGuest = campaign?.member_login_type === MemberLogins.GUEST
  const isMemberLoginTypeSuggest = campaign?.member_login_type === MemberLogins.SUGGEST
  const isMemberLoginTypeRequired = campaign?.member_login_type === MemberLogins.REQUIRED
  const canLogin = isMemberLoginTypeSuggest || isMemberLoginTypeRequired
  const isCampaignClosed = campaign?.status && [CampaignStatus.EXPIRED, CampaignStatus.NOT_YET, CampaignStatus.PAUSED].includes(campaign.status)

  return {
    campaign,
    isMemberLoginTypeGuest,
    isMemberLoginTypeSuggest,
    isMemberLoginTypeRequired,
    isCampaignClosed,
    canLogin,
  }
}
